import { useEffect, useState } from "react";

import styles from "@styles/containers/oraculo/customer-drawer/data-tab.module.scss";

import { Dates } from "@utils/Dates";

import { ForEach, If } from "@components/control-statements";

import { Address } from "@tools/Address";
import classNames from "classnames/bind";
const css = classNames.bind(styles);

export default function ({ customer }) {
  const [collapsed, setCollapsed] = useState(false);
  const [nonRepeatedAddresses, setNonRepeatedAddresses] = useState([]);

  const isArrayEmpty = (value) => {
    return Array.isArray(value) && value.length == 0;
  };

  const calculatePercenteFinish = (data) => {
    const values = [];
    const controllers = ["phone", "name", "email", "birthdate", "addresses"];
    controllers.map((item) => {
      if (
        data[item] !== undefined &&
        !isArrayEmpty(data[item]) &&
        data[item] !== null &&
        data[item] != "" &&
        data[item] != "0000-00-00"
      )
        values.push(data[item]);
    });
  
    return (values.length * 100) / 5;
  };

  const extractAddresses = (customer) => {
    const normalizedAddresses = [];
    if (!customer?.addresses?.length) return setNonRepeatedAddresses([]);

    customer?.addresses?.forEach((addr) => {
      if (Object.keys(addr).length === 0) {
        return false;
      }

      if (addr.geolocation) {
        delete addr.geolocation;
      }

      Object.keys(addr).forEach((key) => {
        if (!addr[key]) {
          return delete addr[key];
        }
        addr[key] =
          typeof addr[key] === "string" ? addr[key].trim() : addr[key];
      });

      normalizedAddresses.push(addr);
    });

    setNonRepeatedAddresses(
      [...new Set(normalizedAddresses.map((a) => JSON.stringify(a)))].map((a) =>
        JSON.parse(a)
      )
    );
  };

  useEffect(() => {
    if (customer) {
      extractAddresses(customer);
    }
  }, [customer]);

  return (
    <div className={styles.registrationData}>
      <div className="d-flex align-center justify-between">
        <p className={styles.title}>Dados cadastrais</p>
        <div
          className={css({
            collapse: true,
            rotate: collapsed,
          })}
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? "Ocultar detalhes" : "Ver detalhes"}{" "}
          <i className="fas fa-chevron-down" />
        </div>
      </div>
      <div
        className={css({
          completeness: true,
          collapsed: collapsed,
        })}
      >
        <div className={styles.progress}>
          <div className={styles.circle}>
            <svg>
              <circle cx="27" cy="27" r="27"></circle>
              <circle
                cx="27"
                cy="27"
                r="27"
                style={{
                  strokeDashoffset: `calc(185 - (185 * ${calculatePercenteFinish(
                    customer
                  )}) / 100)`,
                }}
              ></circle>
            </svg>
            <div
              className={css({
                number: true,
                empty: calculatePercenteFinish(customer) === 0,
              })}
            >
              <span>
                {calculatePercenteFinish(customer) > 0
                  ? `${calculatePercenteFinish(customer)}%`
                  : "---"}
              </span>
            </div>
          </div>
        </div>

        <If cond={!collapsed}>
          <ul className={styles.resumeCompleteness}>
            <li
              className={css({
                complete: !!customer.phone,
              })}
            >
              <span className={styles.dot} /> Telefone
            </li>
            <li
              className={css({
                complete: !!customer.name,
              })}
            >
              <span className={styles.dot} /> Nome
            </li>
            <li
              className={css({
                complete: !!customer.email,
              })}
            >
              <span className={styles.dot} /> Email
            </li>
          </ul>
          <ul className={styles.resumeCompleteness}>
            <li
              className={css({
                complete: !Dates.isEmpty(customer.birthdate),
              })}
            >
              <span className={styles.dot} /> Aniversário
            </li>
            <li
              className={css({
                complete: customer.addresses?.length > 0,
              })}
            >
              <span className={styles.dot} /> Endereço
            </li>
            <li
              className={css({
                complete: !!customer.doc,
              })}
            >
              <span className={styles.dot} /> CPF
            </li>
          </ul>
        </If>

        <If cond={collapsed}>
          <ul className={styles.datailedCompleteness}>
            <li
              className={css({
                complete: !!customer.phone,
              })}
            >
              <div className="d-flex align-center">
                <span className={styles.dot} /> Telefone
              </div>
              <span
                className={css({
                  empty: !customer.phone,
                })}
              >
                {customer.phone}
              </span>
            </li>
            <li
              className={css({
                complete: !!customer.name,
              })}
            >
              <div className="d-flex align-center">
                <span className={styles.dot} /> Nome
              </div>
              <span
                className={css({
                  empty: !customer.name,
                })}
              >
                {customer.name || "---"}
              </span>
            </li>
            <li
              className={css({
                complete: !!customer.email,
              })}
            >
              <div className="d-flex align-center">
                <span className={styles.dot} /> Email
              </div>
              <span
                className={css({
                  empty: !customer.email,
                })}
              >
                {customer.email || "---"}
              </span>
            </li>
            <li
              className={css({
                complete: !Dates.isEmpty(customer.birthdate),
              })}
            >
              <div className="d-flex align-center">
                <span className={styles.dot} /> Aniversário
              </div>
              <span
                className={css({
                  empty: !customer.birthdate,
                })}
              >
                {customer.birthdate
                  ? Dates.toDateBRL(customer.birthdate)
                  : "---"}
              </span>
            </li>
            <li
              className={css({
                complete: !!customer.doc,
              })}
            >
              <div className="d-flex align-center">
                <span className={styles.dot} /> CPF
              </div>
              <span
                className={css({
                  empty: !customer.doc,
                })}
              >
                {customer.doc || "---"}
              </span>
            </li>
            <li
              className={css({
                addressess: nonRepeatedAddresses?.length > 0,
                complete: customer.addresses?.length > 0,
              })}
            >
              <div className="d-flex align-center">
                <span className={styles.dot} /> Endereço
              </div>
              {nonRepeatedAddresses?.length === 0 && (
                <span
                  className={css({
                    empty: nonRepeatedAddresses?.length === 0,
                  })}
                >
                  ---
                </span>
              )}
              <ForEach
                items={nonRepeatedAddresses}
                render={(address) => {
                  const addrString = Address.format(address);
                  return (
                    addrString && (
                      <span className={styles.address}>{addrString}</span>
                    )
                  );
                }}
              />
            </li>
          </ul>
        </If>
      </div>
    </div>
  );
}
